import calc from "../assets/images/calc.svg";
import clock from "../assets/images/clock.svg";
import fcoin from "../assets/images/USD";
import ecoin from "../assets/images/AUD";
import { addComma, gregorianToJalali, isFloat } from "../lib/helperFunctions";
import { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataContext } from "../index";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { DateObject } from "react-multi-date-picker";

function ArchiveTable({ rates, offset }) {
  const calcContext = useContext(DataContext);
  const [showCal, setShowCal] = calcContext.showCalc;

  return (
    <>
      <div className="archive-table-container">
        <table className="archive-table">
          <thead>
            <tr className="bg-archive">
              <th>ردیف</th>
              <th> نماد</th>
              <th>عنوان </th>
              <th>خرید</th>

              <th>فروش</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {rates.rows && rates.rows.length !== 0 ? (
              rates.rows.map((item, i) => {
                const buyPriceStatus =
                  Number(item.buyPrice) > Number(item.pBuyPrice);
                const sellPriceStatus =
                  Number(item.sellPrice) > Number(item.pSellPrice);
                return (
                  <tr>
                    <td>{i + 1 + offset}</td>
                    <td>
                      <span
                        style={{
                          height: "max-content",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {" "}
                        <img
                          style={{ paddingInline: "5px" }}
                          className={`flag`}
                          src={`${
                            item["currency.symbol"]
                              ? `/flags/currencies/${item["currency.symbol"]}@2x.png`
                              : `/flags/coins/${item["coin.id"]}@2x.png`
                          }`}
                        />{" "}
                        {item["currency.symbol"]}{" "}
                      </span>
                    </td>
                    <td>{item["currency.name"] || item["coin.name"]}</td>
                    <td
                      className={`price ${
                        buyPriceStatus ? `green-price` : `red-price`
                      }`}
                    >
                      {addComma(item.buyPrice)}
                    </td>
                    {/* <td>
                                                {buyPriceStatus?<FontAwesomeIcon icon={faArrowUp} style={{ color: "green" }} />:<FontAwesomeIcon icon={faArrowDown} style={{ color: "red" }} />}
                                            </td> */}
                    <td
                      className={`price ${
                        sellPriceStatus ? `green-price` : `red-price`
                      }`}
                    >
                      {addComma(item.sellPrice)}
                    </td>
                    <td>
                      {gregorianToJalali(item.updatedAt).year +
                        "/" +
                        gregorianToJalali(item.updatedAt).month +
                        "/" +
                        gregorianToJalali(item.updatedAt).day +
                        " "}
                      <br />
                      {new Date(item.updatedAt).toString().split(" ")[4]}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                ></td>
                <td className={``}></td>
                <td style={{ fontFamily: "Yekan" }}>
                  ارشیو مورد نظر خود را انتخاب کنید
                </td>
                <td className={`price green-price`}></td>
                <td className={``}></td>
                <td className={``}></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ArchiveTable;
